import React from "react";

const RegionsHeader = () => {
    return (
        <thead>
            <tr>
                <th className="w-[20%] text-start text-ec-body pb-2 text-sm font-normal leading-4 font-inter">
                    Country
                </th>
                <th className="text-start text-ec-body pb-2 text-sm font-normal leading-4 font-inter">
                    State
                </th>
                <th className="text-start text-ec-body pb-2 text-sm font-normal leading-4 font-inter">
                    City
                </th>
                <th className="w-[10%] text-start text-ec-body pb-2 text-sm font-normal leading-4 font-inter">
                    Rate
                </th>
                <th className="w-[10%]"></th>
            </tr>
        </thead>
    );
};

export default RegionsHeader;
